export enum LocalKeys {
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  USER = 'USER',
  PERMISSION = 'PERMISSION'
}
